import { render, staticRenderFns } from "./freightStatistics.vue?vue&type=template&id=30bdbe0d"
import script from "./freightStatistics.vue?vue&type=script&lang=js"
export * from "./freightStatistics.vue?vue&type=script&lang=js"
import style0 from "./freightStatistics.vue?vue&type=style&index=0&id=30bdbe0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports